import SSRIcon from "@ingka/ssr-icon";
import noticeRedSmall from "@ingka/ssr-icon/paths/notice-red-small";
import Text from "@ingka/text";

const ErrorLabel = ({ title }: { title?: string }) => {
  return (
    <div className="helper-text helper-text--error mt-space25">
      <Text tagName="span" bodySize="s">
        <SSRIcon paths={noticeRedSmall} />
      </Text>
      {title}
    </div>
  );
};

export default ErrorLabel;
